var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"ssv-summry-price-box__title"},[_vm._v(_vm._s(_vm.voucher ? 'Cena po slevě:' : 'Cena celkem:'))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"ssv-summry-price-box__price"},[_vm._v(_vm._s(_vm.calculatePrice())+" Kč")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6658c58e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ssv-order/price/PriceCalculation.vue
// module id = null
// module chunks = 